// obtained from https://github.com/andyearnshaw/Intl.js/blob/master/locale-data/json/ko.json
// eslint-disable-next-line no-undef
IntlPolyfill.__addLocaleData({
  locale: 'ko',
  date: {
    ca: ['gregory', 'generic'],
    hourNo0: true,
    hour12: true,
    formats: {
      short: '{1} {0}',
      medium: '{1} {0}',
      full: '{1} {0}',
      long: '{1} {0}',
      availableFormats: {
        d: 'd일',
        E: 'ccc',
        Ed: 'd일 (E)',
        EEEEd: 'd일 EEEE',
        Ehm: '(E) a h:mm',
        EHm: '(E) HH:mm',
        Ehms: '(E) a h:mm:ss',
        EHms: '(E) HH:mm:ss',
        Gy: 'G y년',
        GyMMM: 'G y년 MMM',
        GyMMMd: 'G y년 MMM d일',
        GyMMMEd: 'G y년 MMM d일 (E)',
        GyMMMEEEEd: 'G y년 MMM d일 EEEE',
        h: 'a h시',
        H: 'H시',
        HHmmss: 'HH:mm:ss',
        hm: 'a h:mm',
        Hm: 'HH:mm',
        hms: 'a h:mm:ss',
        Hms: 'H시 m분 s초',
        hmsv: 'a h:mm:ss v',
        Hmsv: 'H시 m분 s초 v',
        hmv: 'a h:mm v',
        Hmv: 'HH:mm v',
        M: 'M월',
        Md: 'M. d.',
        MEd: 'M. d. (E)',
        MEEEEd: 'M. d. EEEE',
        MMM: 'LLL',
        MMMd: 'MMM d일',
        MMMEd: 'MMM d일 (E)',
        MMMEEEEd: 'MMM d일 EEEE',
        MMMMd: 'MMMM d일',
        mmss: 'mm:ss',
        ms: 'mm:ss',
        y: 'y년',
        yM: 'y. M.',
        yMd: 'y. M. d.',
        yMEd: 'y. M. d. (E)',
        yMEEEEd: 'y. M. d. EEEE',
        yMM: 'y. M.',
        yMMM: 'y년 MMM',
        yMMMd: 'y년 MMM d일',
        yMMMEd: 'y년 MMM d일 (E)',
        yMMMEEEEd: 'y년 MMM d일 EEEE',
        yMMMM: 'y년 MMMM',
        yQQQ: 'y년 QQQ',
        yQQQQ: 'y년 QQQQ',
      },
      dateFormats: {
        yMMMMEEEEd: 'y년 M월 d일 EEEE',
        yMMMMd: 'y년 M월 d일',
        yMMMd: 'y. M. d.',
        yMd: 'yy. M. d.',
      },
      timeFormats: {
        hmmsszzzz: 'a h시 m분 s초 zzzz',
        hmsz: 'a h시 m분 s초 z',
        hms: 'a h:mm:ss',
        hm: 'a h:mm',
      },
    },
    calendars: {
      generic: {
        months: {
          narrow: [
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '10',
            '11',
            '12',
          ],
          short: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
          long: [
            'M01',
            'M02',
            'M03',
            'M04',
            'M05',
            'M06',
            'M07',
            'M08',
            'M09',
            'M10',
            'M11',
            'M12',
          ],
        },
        days: {
          narrow: ['일', '월', '화', '수', '목', '금', '토'],
          short: ['일', '월', '화', '수', '목', '금', '토'],
          long: [
            '일요일',
            '월요일',
            '화요일',
            '수요일',
            '목요일',
            '금요일',
            '토요일',
          ],
        },
        eras: {
          narrow: ['ERA0', 'ERA1'],
          short: ['ERA0', 'ERA1'],
          long: ['ERA0', 'ERA1'],
        },
        dayPeriods: { am: '오전', pm: '오후' },
      },
      gregory: {
        months: {
          narrow: [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월',
          ],
          short: [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월',
          ],
          long: [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월',
          ],
        },
        days: {
          narrow: ['일', '월', '화', '수', '목', '금', '토'],
          short: ['일', '월', '화', '수', '목', '금', '토'],
          long: [
            '일요일',
            '월요일',
            '화요일',
            '수요일',
            '목요일',
            '금요일',
            '토요일',
          ],
        },
        eras: {
          narrow: ['BC', 'AD', 'BCE', 'CE'],
          short: ['BC', 'AD', 'BCE', 'CE'],
          long: ['기원전', '서기', 'BCE', 'CE'],
        },
        dayPeriods: { am: '오전', pm: '오후' },
      },
    },
  },
  number: {
    nu: ['latn'],
    patterns: {
      decimal: {
        positivePattern: '{number}',
        negativePattern: '{minusSign}{number}',
      },
      currency: {
        positivePattern: '{currency}{number}',
        negativePattern: '{minusSign}{currency}{number}',
      },
      percent: {
        positivePattern: '{number}{percentSign}',
        negativePattern: '{minusSign}{number}{percentSign}',
      },
    },
    symbols: {
      latn: {
        decimal: '.',
        group: ',',
        nan: 'NaN',
        plusSign: '+',
        minusSign: '-',
        percentSign: '%',
        infinity: '∞',
      },
    },
    currencies: {
      AUD: 'AU$',
      BRL: 'R$',
      CAD: 'CA$',
      CNY: 'CN¥',
      EUR: '€',
      GBP: '£',
      HKD: 'HK$',
      ILS: '₪',
      INR: '₹',
      JPY: 'JP¥',
      KRW: '₩',
      MXN: 'MX$',
      NZD: 'NZ$',
      THB: '฿',
      TWD: 'NT$',
      USD: 'US$',
      VND: '₫',
      XAF: 'FCFA',
      XCD: 'EC$',
      XOF: 'CFA',
      XPF: 'CFPF',
    },
  },
})
